import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '@fortem-monorepo/js-utilities';
const badgeVariants = cva('inline-flex items-center justify-center rounded-md border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden', {
    variants: {
        variant: {
            default: 'border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90',
            secondary: 'border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90',
            outline: 'text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground',
        },
        theme: {
            destructive: 'bg-red-100 border-red-200 text-red-600',
            success: 'bg-green-100 border-green-300 text-green-600',
            warning: 'bg-amber-100 border-amber-400 text-amber-600',
            info: 'bg-blue-100 border-blue-200 text-blue-600',
        },
        size: {
            default: 'px-2 py-0.5 text-xs',
            large: 'px-2 py-0.5 text-sm',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});
function Badge({ className, variant, size, theme, asChild = false, ...props }) {
    const Comp = asChild ? Slot : 'span';
    return (_jsx(Comp, { "data-slot": "badge", className: cn(badgeVariants({ variant, size, theme }), className), ...props }));
}
export { Badge, badgeVariants };
